// extracted by mini-css-extract-plugin
export default {"toggler":"toggler_toggler__sl9PH","label":"toggler_label__Jh6-B"};